exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-test-question-answer-card[data-v-4fa8d7a2] {\n  height: 55px !important;\n  border: none !important;\n}\n.question-editor-tab-form .label[data-v-4fa8d7a2] {\n  margin-bottom: 20px;\n}\n.question-editor-tab-form .label.answer-section-label[data-v-4fa8d7a2] {\n  margin-bottom: 0;\n}\n.question-editor-tab-form .label[data-v-4fa8d7a2]:not(:first-child) {\n  margin-top: 20px;\n}", ""]);

// exports
